/**
 * Frontend-копия src/constants/integrationsAccess.js.
 *
 * Дублируется потому что нет shared между frontend/backend кодом
 * в проекте. Любое изменение здесь должно повторяться в backend
 * (и наоборот) — так задумано пока.
 */

const INTEGRATIONS_ADMIN_EMAILS = new Set([
  'maks.skripchenkov@yandex.ru',
  'maks.skripchenkov@ya.ru'
])

export function isIntegrationsAdmin(user) {
  if (!user || !user.email) return false
  return INTEGRATIONS_ADMIN_EMAILS.has(user.email.toLowerCase().trim())
}
